import { Button, styled } from "@mui/material";

export const CircleButton = styled(Button)<{ diameter?: number }>(({ diameter = 55, ...props }) => ({
    width: diameter,
    height: diameter,
    borderRadius: "50%",
    minWidth: "30px",
    minHeight: "30px",
    boxShadow: "0px 1.33784px 2.67568px rgba(0, 0, 0, 0.2), 0px 2.67568px 5.35135px rgba(0, 0, 0, 0.2)",
}));
